import comment from "./comment";

export default comment;
